module.exports = __webpack_public_path__ + "static/media/battles-background-main.cae6c47f.png";